import { FormattedMessage, useIntl } from 'react-intl';
import { Fade, Stack } from '@mui/material';
import { FilterMultiSelect, SearchField, renderCheckboxOption } from '@atoms/inputs';
import { Box, Flex } from '@atoms/layout';
import { Button } from '@atoms/buttons';
import { FaIcon } from '@atoms/icons';
import { ActiveFilters } from '@molecules/dataDisplay';
import { FilterItem } from '@molecules/dataDisplay/activeFilters';
import { INVITATION_STATUSES_LIST } from '@libs/models/organization';
import { useAgenciesListFiltersStore } from '@libs/store/agencies';

type ShiftsFiltersProps = {
  loading: boolean;
  localizationSubset: string;
};
export function AgenciesFilters({ loading, localizationSubset }: ShiftsFiltersProps) {
  const intl = useIntl();
  const { activeFilters, clearFilter, clearFilters, getFilter, setFilterFromOptions, setFilter } =
    useAgenciesListFiltersStore();

  const statusesOptions =
    INVITATION_STATUSES_LIST.map((status) => ({
      label: intl.formatMessage({ id: `${localizationSubset}.statuses.${status.toLowerCase()}` }),
      value: status,
    })) || [];

  return (
    <Stack direction={'column'} spacing={1}>
      <Flex justifyContent="space-between" gap={2}>
        <Flex gap={2} flexWrap="wrap">
          <Box width={220}>
            <FilterMultiSelect
              size="small"
              disabled={true}
              options={statusesOptions}
              inlineLabel
              label={`${intl.formatMessage({ id: `${localizationSubset}.filters.status.label` })}:`}
              fullWidth
              renderOption={renderCheckboxOption}
              onApply={(v) => setFilterFromOptions('status', v, statusesOptions)}
              onClear={() => clearFilter('status')}
              value={getFilter<string[]>('status')?.value ?? []}
            />
          </Box>
          <Fade in={activeFilters.length > 0} timeout={150}>
            <Button
              variant="passive"
              onClick={() => clearFilters()}
              startIcon={<FaIcon name="xmark" />}
              sx={{ ml: 'auto' }}
            >
              <FormattedMessage id="common.clearAllFilters" />
            </Button>
          </Fade>
        </Flex>
        <SearchField
          sx={{ width: 260, flexShrink: 0 }}
          value={getFilter<string>('search')?.value ?? ''}
          onChange={(elem: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
            setFilter({ key: 'search', value: elem.target.value })
          }
        />
      </Flex>
      <Stack direction={'row'} spacing={2}>
        <ActiveFilters
          filters={activeFilters.reduce((acc, f) => {
            if (f.key === 'locations') {
              return acc;
            }
            acc.push({
              ...f,
              label: <FormattedMessage id={`${localizationSubset}.filters.${f.key}.label`} />,
            });
            return acc;
          }, [] as FilterItem[])}
          onDelete={(item) => clearFilter(item.key)}
        />
      </Stack>
    </Stack>
  );
}
